"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));
var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var sportnet_utilities_1 = require("sportnet-utilities");
var styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
var utilities_2 = require("../utilities");
var responsiveSize = 'm';
var maxCountOfSearch = 5;
var Wrapper = (0, styled_components_1["default"])('div')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  padding: 0 ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: ", ";\n  padding: 0 ", ";\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return (0, polished_1.rem)(theme.app.padding);
});
var SearchInputWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  flex: 1 0 0;\n"], ["\n  flex: 1 0 0;\n"])));
var SearchInput = (0, styled_components_1["default"])('input')(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  border: none;\n  outline: none;\n  font-size: ", ";\n  width: 100%;\n  margin: 0;\n  padding: 0 ", ";\n  line-height: ", ";\n  font-family: 'Open Sans', sans-serif;\n  color: ", ";\n  ::placeholder {\n    color: ", ";\n    opacity: 0.5;\n  }\n  background: none;\n"], ["\n  border: none;\n  outline: none;\n  font-size: ", ";\n  width: 100%;\n  margin: 0;\n  padding: 0 ", ";\n  line-height: ", ";\n  font-family: 'Open Sans', sans-serif;\n  color: ", ";\n  ::placeholder {\n    color: ", ";\n    opacity: 0.5;\n  }\n  background: none;\n"])), (0, polished_1.rem)(18), (0, polished_1.rem)(10), (0, polished_1.rem)(40), function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var color = _a.color;
    return color;
});
var StyledMediaManagerImage = (0, styled_components_1["default"])(MediaManagerImage_1["default"])(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  width: 24px;\n  margin-right: 13px;\n"], ["\n  width: 24px;\n  margin-right: 13px;\n"])));
var SearchContainer = (0, styled_components_1["default"])('div')(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var IconButton = (0, styled_components_1["default"])('button')(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  border: none;\n  background: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin-left: ", ";\n  :active {\n    outline: none;\n  }\n  ", ";\n  ", " {\n    margin-left: 0;\n    ", ";\n  }\n"], ["\n  border: none;\n  background: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  margin-left: ", ";\n  :active {\n    outline: none;\n  }\n  ", ";\n  ", " {\n    margin-left: 0;\n    ", ";\n  }\n"])), (0, polished_1.rem)(15), function (_a) {
    var searchActive = _a.searchActive;
    return searchActive && (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
}, (0, utilities_1.mb)(responsiveSize), function (_a) {
    var searchActive = _a.searchActive;
    return searchActive && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n        display: flex;\n      "], ["\n        display: flex;\n      "])));
});
var IconButtonBack = (0, styled_components_1["default"])(IconButton)(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n  margin-left: 0;\n  ", " {\n    display: none;\n  }\n"], ["\n  margin-left: 0;\n  ", " {\n    display: none;\n  }\n"])), (0, utilities_1.mb)(responsiveSize));
var Items = styled_components_1["default"].ul(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  z-index: 21;\n  max-height: ", ";\n  overflow-y: auto;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);\n"], ["\n  position: absolute;\n  z-index: 21;\n  max-height: ", ";\n  overflow-y: auto;\n  width: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);\n"])), (0, polished_1.rem)(300));
var ItemLabel = styled_components_1["default"].span(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  align-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  align-content: center;\n  align-items: center;\n"])));
var Item = (0, styled_components_1["default"])('li')(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  display: flex;\n  width: 100%;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  padding: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n\n  background: ", ";\n  color: ", ";\n\n  ", ";\n"], ["\n  font-size: ", ";\n  display: flex;\n  width: 100%;\n  position: relative;\n  align-content: center;\n  align-items: center;\n  padding: ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n\n  background: ", ";\n  color: ", ";\n\n  ", ";\n"])), (0, polished_1.rem)(14), (0, polished_1.rem)(10), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var color = _a.color;
    return color;
}, function (_a) {
    var active = _a.active, theme = _a.theme;
    if (active) {
        return (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n        background-color: ", ";\n        color: ", ";\n      "], ["\n        background-color: ", ";\n        color: ", ";\n      "])), theme.color.primaryBg, theme.color.primary);
    }
    return '';
});
var MoreItemsLabel = (0, styled_components_1["default"])(ItemLabel)(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject(["\n  display: block;\n"], ["\n  display: block;\n"])));
var C = function (props) {
    var startElement = props.startElement, onSearchSubmit = props.onSearchSubmit, searchQuery = props.searchQuery, textColor = props.textColor, onSearchSubmitItem = props.onSearchSubmitItem, searchActive = props.searchActive, setSearchActive = props.setSearchActive, onChangeSearchQuery = props.onChangeSearchQuery, backgroundColor = props.backgroundColor, getItems = props.getItems;
    var _a = React.useState({}), itemsByQuery = _a[0], setItemsByQuery = _a[1];
    var _b = React.useState(-1), focusItemIndex = _b[0], setFocusItemIndex = _b[1];
    var searchInputRef = React.useRef(null);
    var dataItem = (0, sportnet_utilities_1.getProp)(itemsByQuery, [searchQuery, 'itemsByQuery'], []);
    React.useEffect(function () {
        var inputEl = searchInputRef.current;
        if (searchActive && inputEl) {
            inputEl.focus();
        }
        if (searchQuery.length > 0) {
            setItemsByQuery(function (prev) {
                var _a;
                return (tslib_1.__assign(tslib_1.__assign({}, prev), (_a = {}, _a[searchQuery] = { itemsByQuery: [], isFetching: true }, _a)));
            });
            if (searchQuery in itemsByQuery && itemsByQuery[searchQuery].isFetching) {
                //
            }
            else {
                if (!!getItems) {
                    getItems(searchQuery).then(function (resp) {
                        setItemsByQuery(function (prev) {
                            var _a;
                            return (tslib_1.__assign(tslib_1.__assign({}, prev), (_a = {}, _a[searchQuery] = { itemsByQuery: resp, isFetching: false }, _a)));
                        });
                    });
                }
            }
        }
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [searchActive, searchQuery]);
    var handleSearch = function (e) {
        if (onChangeSearchQuery) {
            onChangeSearchQuery(e.currentTarget.value);
        }
    };
    var handleSearchSubmit = function () {
        if (onSearchSubmit && searchQuery) {
            onSearchSubmit();
            setSearchActive(false);
            setFocusItemIndex(-1);
        }
    };
    var handleSearchSubmitItem = function (item) {
        if (onSearchSubmitItem) {
            onSearchSubmitItem(item);
            setSearchActive(false);
            setFocusItemIndex(-1);
        }
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            if (focusItemIndex < 0 || focusItemIndex === maxCountOfSearch - 1) {
                handleSearchSubmit();
            }
            else {
                handleSearchSubmitItem(dataItem[focusItemIndex]);
            }
        }
        if (dataItem.length > 0 && e.key === 'ArrowDown') {
            e.preventDefault();
            setFocusItemIndex((focusItemIndex + 1) %
                (dataItem.length > maxCountOfSearch
                    ? maxCountOfSearch
                    : dataItem.length));
        }
        else if (dataItem.length > 0 && e.key === 'ArrowUp') {
            e.preventDefault();
            setFocusItemIndex((focusItemIndex + dataItem.length) %
                (dataItem.length > maxCountOfSearch
                    ? maxCountOfSearch
                    : dataItem.length));
        }
        else {
            setFocusItemIndex(-1);
        }
    };
    var renderItem = function (item, idx) {
        return (idx < maxCountOfSearch && (React.createElement(Item, { key: idx, active: idx === focusItemIndex, onMouseDown: function () {
                if (idx < maxCountOfSearch - 1) {
                    handleSearchSubmitItem(item);
                }
                else {
                    handleSearchSubmit();
                }
            }, onMouseEnter: function () {
                setFocusItemIndex(idx);
            }, backgroundColor: backgroundColor, color: textColor, idx: idx }, idx < maxCountOfSearch - 1 ? (React.createElement(ItemLabel, null,
            item.icon && (React.createElement(StyledMediaManagerImage, { picture: item.icon, naturalHeight: 24, naturalWidth: 24 })),
            item.label)) : (React.createElement(MoreItemsLabel, null, "\u010Eal\u0161ie v\u00FDsledky ...")))));
    };
    if (!searchActive) {
        return null;
    }
    return (React.createElement(Wrapper, { backgroundColor: backgroundColor },
        startElement,
        React.createElement(IconButton, { onClick: handleSearchSubmit, key: "redirect-to-search", searchActive: searchActive, "data-testid": "CL_Search_Icon_Search_Active" },
            React.createElement(Icon_1["default"], { name: "search", color: textColor, size: 28 })),
        React.createElement(IconButtonBack, { onClick: function () {
                setSearchActive(false);
                onChangeSearchQuery('');
            }, key: "close-search" },
            React.createElement(Icon_1["default"], { name: "arrow-left", color: textColor, size: 28 })),
        React.createElement(SearchInputWrapper, null,
            React.createElement(SearchInput, { value: searchQuery, onChange: handleSearch, placeholder: (0, utilities_2.__)('Zadajte hľadaný výraz ...'), color: textColor, ref: searchInputRef, onKeyDown: function (e) {
                    handleKeyDown(e);
                }, onMouseEnter: function () {
                    setFocusItemIndex(-1);
                } }),
            React.createElement(SearchContainer, null,
                React.createElement(Items, null, dataItem.map(renderItem)))),
        React.createElement(IconButton, { onClick: function () {
                setSearchActive(false);
                onChangeSearchQuery('');
            }, searchActive: searchActive, "data-testid": "CL_Search_Icon_Close" },
            React.createElement(Icon_1["default"], { name: "close", size: 24, color: textColor }))));
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
